const content = {
  year: '2026',
  day1: {
    day: 'Mercredi 17 juin',
    hours: '8h - 18h30',
  },
  day2: {
    day: 'Jeudi 18 juin',
    hours: '8h - 17h00',
  },
  exhibition: {
    date: 'les 17 et 18 juin à Nantes',
  },
};

/** Prénom et nom : même limite que sur le PDF badge (tous types d’inscription). */
export const PROFILE_FIRST_LAST_NAME_MAX_LENGTH = 20;

export const registerTypes = [
  {
    value: 'collaborateur',
    label: 'Collaborateur centrale',
  },
  {
    value: 'magasin',
    label: 'Magasin',
  },
  {
    value: 'fournisseur',
    label: 'Fournisseur',
  },
];

export const userFunctions = [
  {
    value: 'Associé(e)',
    label: 'Associé(e)',
  },
  {
    value: 'Directeur(trice)',
    label: 'Directeur(trice)',
  },
  {
    value: 'Collaborateur(trice) ELDPH - FLS',
    label: 'Collaborateur(trice) ELDPH - FLS',
  },
  {
    value: 'Collaborateur(trice) Bazar',
    label: 'Collaborateur(trice) Bazar',
  },
  {
    value: 'Collaborateur(trice) U Location',
    label: 'Collaborateur(trice) U Location',
  },
  {
    value: 'Collaborateur(trice) Textile',
    label: 'Collaborateur(trice) Textile',
  },
  {
    value: 'Fonction transverse (Drive, Com, RH,....)',
    label: 'Fonction transverse (Drive, Com, RH,....)',
  },
];

export const CONTACT_EMAIL = 'cooperativeu_salon_bazar@systeme-u.fr';

/** Lien public vers le plan du salon (fichier servi depuis `public/download/`) */
export const URL_FORMATIONS = 'https://unisvers-u.prod.gcp.groupement.systeme-u.fr/jcms/prod2_21875891/salon-cooperative-u-2026-formations-conferences';

export default content;
